module.exports = __webpack_public_path__ + "static/Preview-6513ae26c316b85be1334281a83a5507.jpg";